import React from 'react';
import { GlobalSearchItem, GlobalSearchStateItem } from '../interfaces/global-search';
import HdIcon from '../../media/components/icon/HdIcon';

export function GlobalSearchEntityListItemContent({
  entityItem,
  entity
}: { entityItem: GlobalSearchItem; entity: GlobalSearchStateItem }) {

  const { renderItem } = entity.metaData;

  return (
    <div className='center-flex-row w-100'>
      {renderItem ? renderItem(entityItem) : (
        <>
          <HdIcon name={entityItem.icon} className='mr-2' />

          <span className='text-ellipsis text-medium text-ellipsis'>{entityItem.name}</span>
        </>
      )}
    </div>
  );
}
